import _regeneratorRuntime from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  "class": "message-video"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = ["src", "poster"];
var _hoisted_4 = ["src", "poster"];
var _hoisted_5 = {
  key: 0,
  "class": "dialog-video"
};
var _hoisted_6 = ["src"];
import { ref, watch, computed, nextTick, watchEffect } from "../../../../adapter-vue";
import { handleSkeletonSize } from "../../utils/utils";
import Icon from "../../../common/Icon.vue";
import closeSVG from "../../../../assets/icon/icon-close.svg";
import { isPC } from "../../../../utils/env";
var transparentPosterUrl = "https://web.sdk.qcloud.com/im/assets/images/transparent.png";
export default /*@__PURE__*/_defineComponent({
  __name: 'message-video',
  props: {
    content: {
      "default": function _default() {
        return {};
      }
    },
    messageItem: {
      "default": function _default() {
        return {};
      }
    }
  },
  emits: ["uploading"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var isShow = ref(false);
    var poster = ref("");
    var posterWidth = ref(0);
    var posterHeight = ref(0);
    var skeleton = ref();
    var videoRef = ref();
    watchEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (props.content) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.next = 4;
            return handlePosterUrl(props.content, props.messageItem);
          case 4:
            poster.value = _context2.sent;
            nextTick(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var _document$getElementB;
              var containerWidth, max, size, _skeleton$value, _skeleton$value2, _props$content, _props$content$snapsh, snapshotWidth, _props$content$snapsh2, snapshotHeight, snapshotUrl, _videoRef$value, _videoRef$value2;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    containerWidth = ((_document$getElementB = document.getElementById("messageScrollList")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.clientWidth) || 0;
                    max = !isPC ? Math.min(containerWidth - 172, 300) : 300;
                    if (!(props.messageItem.status === "success")) {
                      _context.next = 13;
                      break;
                    }
                    _props$content = props.content, _props$content$snapsh = _props$content.snapshotWidth, snapshotWidth = _props$content$snapsh === void 0 ? 0 : _props$content$snapsh, _props$content$snapsh2 = _props$content.snapshotHeight, snapshotHeight = _props$content$snapsh2 === void 0 ? 0 : _props$content$snapsh2, snapshotUrl = _props$content.snapshotUrl;
                    if (!(snapshotWidth === 0 || snapshotHeight === 0)) {
                      _context.next = 6;
                      break;
                    }
                    return _context.abrupt("return");
                  case 6:
                    if (snapshotUrl === transparentPosterUrl) {
                      snapshotWidth = posterWidth.value;
                      snapshotHeight = posterHeight.value;
                    }
                    size = handleSkeletonSize(snapshotWidth, snapshotHeight, max, max);
                    (skeleton === null || skeleton === void 0 || (_skeleton$value = skeleton.value) === null || _skeleton$value === void 0 ? void 0 : _skeleton$value.style) && (skeleton.value.style.width = "".concat(size.width, "px"));
                    (skeleton === null || skeleton === void 0 || (_skeleton$value2 = skeleton.value) === null || _skeleton$value2 === void 0 ? void 0 : _skeleton$value2.style) && (skeleton.value.style.height = "".concat(size.height, "px"));
                    if (isPC) {
                      (videoRef === null || videoRef === void 0 || (_videoRef$value = videoRef.value) === null || _videoRef$value === void 0 ? void 0 : _videoRef$value.style) && (videoRef.value.style.width = "".concat(size.width, "px"));
                      (videoRef === null || videoRef === void 0 || (_videoRef$value2 = videoRef.value) === null || _videoRef$value2 === void 0 ? void 0 : _videoRef$value2.style) && (videoRef.value.style.height = "".concat(size.height, "px"));
                    }
                    _context.next = 14;
                    break;
                  case 13:
                    emits("uploading");
                  case 14:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            })));
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    var isWidth = computed(function () {
      var _props$messageItem$pa = props.messageItem.payload,
        _props$messageItem$pa2 = _props$messageItem$pa.snapshotWidth,
        snapshotWidth = _props$messageItem$pa2 === void 0 ? 0 : _props$messageItem$pa2,
        _props$messageItem$pa3 = _props$messageItem$pa.snapshotHeight,
        snapshotHeight = _props$messageItem$pa3 === void 0 ? 0 : _props$messageItem$pa3;
      return snapshotWidth >= snapshotHeight;
    });
    watch(function () {
      return props.messageItem.status;
    }, function (newVal, oldVal) {
      if (newVal === "success" && oldVal !== "success") {
        emits("uploading");
      }
    });
    function toggleVideoPreviewer() {
      // 视频上传过程中不支持全屏播放
      if (props.messageItem.progress > 0 && props.messageItem.progress < 1) {
        return;
      }
      isShow.value = !isShow.value;
    }
    // h5 部分浏览器（safari / wx）video标签 封面为空 在视频未上传完成前的封面展示需要单独进行处理截取
    function getVideoBase64(url) {
      return new Promise(function (resolve) {
        var dataURL = "";
        var video = document.createElement("video");
        video.setAttribute("crossOrigin", "anonymous"); //处理跨域
        video.setAttribute("src", url);
        video.setAttribute("preload", "auto");
        video.addEventListener("loadeddata", function () {
          var canvas = document.createElement("canvas"),
            width = video.videoWidth,
            //canvas的尺寸和图片一样
            height = video.videoHeight;
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(video, 0, 0, width, height); //绘制canvas
          dataURL = canvas.toDataURL("image/jpeg"); //转换为base64
          posterWidth.value = width;
          posterHeight.value = height;
          resolve(dataURL);
        }, {
          once: true
        });
      });
    }
    function handlePosterUrl(_x, _x2) {
      return _handlePosterUrl.apply(this, arguments);
    }
    function _handlePosterUrl() {
      _handlePosterUrl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(messgeContent, messageItem) {
        var _messageItem$payload, _messageItem$payload2, _messageItem$payload3, _messageItem$payload4;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (messageItem) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", "");
            case 2:
              if (!(messageItem.status !== "success")) {
                _context3.next = 8;
                break;
              }
              _context3.next = 5;
              return getVideoBase64(messgeContent.url);
            case 5:
              return _context3.abrupt("return", _context3.sent);
            case 8:
              _context3.t0 = messgeContent.snapshotUrl !== transparentPosterUrl && messgeContent.snapshotUrl || (messageItem === null || messageItem === void 0 || (_messageItem$payload = messageItem.payload) === null || _messageItem$payload === void 0 ? void 0 : _messageItem$payload.snapshotUrl) !== transparentPosterUrl && (messageItem === null || messageItem === void 0 || (_messageItem$payload2 = messageItem.payload) === null || _messageItem$payload2 === void 0 ? void 0 : _messageItem$payload2.snapshotUrl) || ((_messageItem$payload3 = messageItem.payload) === null || _messageItem$payload3 === void 0 ? void 0 : _messageItem$payload3.thumbUrl) !== transparentPosterUrl && (messageItem === null || messageItem === void 0 || (_messageItem$payload4 = messageItem.payload) === null || _messageItem$payload4 === void 0 ? void 0 : _messageItem$payload4.thumbUrl);
              if (_context3.t0) {
                _context3.next = 13;
                break;
              }
              _context3.next = 12;
              return getVideoBase64(messgeContent.url);
            case 12:
              _context3.t0 = _context3.sent;
            case 13:
              return _context3.abrupt("return", _context3.t0);
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _handlePosterUrl.apply(this, arguments);
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        "class": _normalizeClass(["message-video-box", [(!props.messageItem.progress || props.messageItem.progress === 1) && !_unref(isPC) && 'message-video-cover']]),
        onClick: toggleVideoPreviewer,
        ref_key: "skeleton",
        ref: skeleton
      }, [props.messageItem.progress > 0 && props.messageItem.progress < 1 && _unref(poster) || !_unref(isPC) && _unref(poster) ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        "class": _normalizeClass(["message-img", [_unref(isWidth) ? 'isWidth' : 'isHeight']]),
        src: _unref(poster)
      }, null, 10, _hoisted_2)) : !_unref(isPC) ? (_openBlock(), _createElementBlock("video", {
        key: 1,
        "class": "message-img video-h5-uploading",
        src: props.content.url + '#t=0.1',
        poster: props.content.url,
        preload: "auto",
        muted: "",
        ref_key: "videoRef",
        ref: videoRef
      }, null, 8, _hoisted_3)) : (_openBlock(), _createElementBlock("video", {
        key: 2,
        "class": "message-img video-web",
        src: props.content.url,
        controls: "",
        preload: "metadata",
        poster: _unref(poster),
        ref_key: "videoRef",
        ref: videoRef
      }, null, 8, _hoisted_4))], 2), _unref(isShow) && !_unref(isPC) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
        onClick: _withModifiers(toggleVideoPreviewer, ["stop"]),
        "class": "dialog-video-close"
      }, [_createVNode(Icon, {
        file: _unref(closeSVG)
      }, null, 8, ["file"])]), _createElementVNode("div", {
        "class": _normalizeClass(["dialog-video-box", [!_unref(isPC) ? 'dialog-video-h5' : '']]),
        onClick: _withModifiers(toggleVideoPreviewer, ["self"])
      }, [_createElementVNode("video", {
        "class": _normalizeClass([_unref(isWidth) ? 'isWidth' : 'isHeight']),
        src: props.content.url,
        controls: "",
        autoplay: ""
      }, null, 10, _hoisted_6)], 2)])) : _createCommentVNode("", true)]);
    };
  }
});